import { facetColumnNames } from '../states'; // mirrors ui-search's buildProductFilters, limited to the base facets plus any selected
// Approved Use attribute facets
//
// excludeFacetId leaves a given facet's own selection out of the filter list - used when
// computing that facet's own available options, so picking a value doesn't narrow its own
// dropdown down to just that value
//
// includeAttributeFilters defaults to true; pass false when computing the Approved Use facet's
// own option list, since its own attribute selections only apply to the currently-selected
// Approved Use and would otherwise incorrectly zero out every other Approved Use's options
export function buildProductSearchFilters(state, excludeFacetId) { var includeAttributeFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true; var filters = []; Object.keys(facetColumnNames).forEach(function (facetId) { if (facetId === excludeFacetId)
    return; var selectedValue = state.facets[facetId].selectedValues[0]; if (selectedValue) {
    filters.push({ column: facetColumnNames[facetId], value: selectedValue, operator: '=' });
} }); if (includeAttributeFilters) {
    state.approvedUseAttributeGroups.forEach(function (group) { var selectedValue = group.selectedValues[0]; if (selectedValue && group.operator !== '!=') {
        filters.push({ column: group.columnName, value: selectedValue, operator: group.operator });
    } });
} return filters; }
